export default __webpack_public_path__ + "static/assets/9225ee65dacc988b4b52fd6955c3067f.svg";